import React from 'react';

import { classNames } from '@thinkific/chalk/utils';

import * as css from './MenuIcon.css';

interface MenuIconProps {
  className?: string;
  iconName: React.ElementType;
  iconSize?: 'sm' | 'md';
  statusIndicator?: React.ReactNode;
  hasSurface?: boolean;
}

// Used as wrapper component for MenuItem components
const MenuIcon = ({
  className,
  iconName,
  iconSize = 'md',
  hasSurface,
  statusIndicator,
}: MenuIconProps) => {
  const Icon = iconName;

  return (
    <div className={classNames(css.spaceIcon, className)}>
      <div
        className={classNames(
          css.spaceIconInner,
          hasSurface && css.iconSurface,
          !!statusIndicator && css.statusIndicator
        )}
      >
        <Icon size={iconSize} />
      </div>
      {statusIndicator}
    </div>
  );
};

export default MenuIcon;
